import { DashboardOutlined, UserSwitchOutlined, BankOutlined, UsergroupAddOutlined, DollarCircleOutlined, CreditCardOutlined, HeartOutlined, SolutionOutlined, TransactionOutlined, FileSearchOutlined, ThunderboltOutlined } from '@ant-design/icons';
const icons = {
  DashboardOutlined,
  UserSwitchOutlined,
  BankOutlined,
  UsergroupAddOutlined,
  DollarCircleOutlined,
  CreditCardOutlined,
  HeartOutlined,
  SolutionOutlined,
  TransactionOutlined,
  FileSearchOutlined,
  ThunderboltOutlined
};

const adminMenu = {
  items: [
    {
      id: 'group-dashboard',
      title: 'Dashboard',
      type: 'group',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/admin/dashboard',
          icon: icons.DashboardOutlined,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'users',
      title: 'User Management',
      type: 'group',
      children: [
        {
          id: 'users',
          title: 'Users',
          type: 'item',
          url: '/admin/users',
          icon: icons.UserSwitchOutlined,
          breadcrumbs: false
        },
        {
          id: 'Institution',
          title: 'Institutions',
          type: 'item',
          url: '/admin/institution',
          icon: icons.BankOutlined,
          target: false
        },
        {
          id: 'institutionRequests',
          title: 'Institution Requests',
          type: 'item',
          url: '/admin/institution-requests',
          icon: icons.FileSearchOutlined,
          target: false
        },
        {
          id: 'beneficiary',
          title: 'Beneficiaries',
          type: 'item',
          url: '/admin/beneficiary',
          icon: icons.UsergroupAddOutlined
        },
        {
          id: 'Donors',
          title: 'Donors',
          type: 'item',
          url: '/admin/donor',
          icon: icons.DollarCircleOutlined
        },
      ]
    },
    {
      id: 'transactions',
      title: 'Transactions',
      type: 'group',
      children: [
        {
          id: 'requests',
          title: 'Requests',
          type: 'item',
          url: '/admin/requests',
          icon: icons.SolutionOutlined
        },
        {
          id: 'donations',
          title: 'Donations',
          type: 'item',
          url: '/admin/donations',
          icon: icons.HeartOutlined
        },
        {
          id: 'quickDonations',
          title: 'Quick Donations',
          type: 'item',
          url: '/admin/quick-donations',
          icon: icons.ThunderboltOutlined
        },
        {
          id: 'fundDisbursement',
          title: 'Fund Disbursement',
          type: 'item',
          url: '/admin/fund-disbursement',
          icon: icons.TransactionOutlined
        },
        {
          id: 'payments',
          title: 'Payments',
          type: 'item',
          url: '/admin/payments',
          icon: icons.CreditCardOutlined
        },
      ]
    }
  ]
};

// const instituitionMenu = {
//   items: [
//     {
//       id: 'group-dashboard',
//       title: 'Dashboard',
//       type: 'group',
//       children: [
//         {
//           id: 'dashboard',
//           title: 'Dashboard',
//           type: 'item',
//           url: '/dashboard/default',
//           icon: icons.DashboardOutlined,
//           breadcrumbs: false
//         }
//       ]
//     },
//     {
//       id: 'users',
//       title: 'Users',
//       type: 'group',
//       children: [
//         {
//           id: 'Institution',
//           title: 'Institution',
//           type: 'item',
//           url: '/institution',
//           icon: icons.BankOutlined,
//           target: false
//         },
//         {
//           id: 'beneficiary',
//           title: 'Beneficiary',
//           type: 'item',
//           url: '/beneficiary',
//           icon: icons.UsergroupAddOutlined
//         }
//       ]
//     }
//   ]
// };

export default adminMenu;
